module.exports = __webpack_public_path__ + "static/media/close2.fc17b8f2.svg";